const contact = {
  email: { name: "email", value: "edinsikira5@gmail.com" },

  linkedin: {
    name: "linkedin",
    value: "https://www.linkedin.com/in/edin-sikira-3b2013217/",
  },
};
export { contact };
